import { useSelector } from 'react-redux';
import Context from '@alltrails/types/Context';

export default function useApexDomain(): string {
  return useSelector((state: { context: Context }) => state.context?.apexDomain!);
}
